export type CategoriaVehiculo = 'coche' | 'moto'

export enum CategoriaVehiculoEnum {
  COCHE = 'coche',
  MOTO = 'moto',
}

export interface Vehicle {
  ano_fabric: number
  ano_matric: number
  mes_matric: string
  cod_matricula: string
  combustible_tipo: string
  fecha_desde: string
  id_marca: number
  id_modelo: number
  id_vehiculo: number
  marca: string
  modelo: string
  motor: string
  potencia_cilindrada: number
  potencia_cv: number
  potencia_kw: number
  cod_motor: string
  imagen: string
  capacidad_carter: string
}
